import { AppSettingsModel } from "@/util/constants";
import { GLGlobal, GLServiceBase, ServiceRoute } from "commonui";

export class SettingServiceClass extends GLServiceBase<any, any> {
	serviceRoute: ServiceRoute = { prefix: "" };
	/**
	 * Version data is independent of auth, so need to bypass common ui implementation of
	 * web -> gateway (for auth) -> account service.
	 * request.agent().get() will execute like web -> account service.
	 */
	getSettings(): Promise<AppSettingsModel> {
		return new Promise((resolve, reject) => {
			this.request
				.agent()
				.get(`${GLGlobal.authorityUrl()}/api/versions/version`)
				.end((_, res) => {
					resolve(res && res.ok ? res.body : {});
				});
		});
	}
}

export const SettingService = new SettingServiceClass();
